<template>

  
  <div class="bg-grey-lighten-4 home-scroll-container" v-if="!isLoading">

    <!-- 🔴 PANTALLA DE ERROR (Si falla la carga por fecha/red) -->
    <div v-if="isError" class="d-flex flex-column align-center justify-center fill-height pa-6 text-center" style="min-height: 80vh;">
        <v-icon size="80" color="grey-lighten-1" class="mb-4">mdi-clock-alert-outline</v-icon>
        <h3 class="text-h6 font-weight-bold text-blue-grey-darken-3">Error de Sincronización</h3>
        <p class="text-body-2 text-grey-darken-1 my-3">
          No pudimos conectar con el servidor. Esto suele ocurrir si no tienes internet o si la 
          <strong>fecha y hora</strong> de tu dispositivo son incorrectas.
        </p>
        <v-btn color="blue-darken-4" rounded="pill" prepend-icon="mdi-refresh" @click="retryLoad">Reintentar</v-btn>
    </div>

    <div v-else>
    <v-navigation-drawer v-model="drawer" temporary density="compact" style="padding-top: 56px" class="elevation-5">
      <v-list>
        <v-list-item link to="/home" @click="closeDrawer">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://tse2.mm.bing.net/th/id/OIP.MS5OosTTRq5tUOV31w9EEAHaHa?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3" />
            </v-avatar>
          </template>
          <v-list-item-title class="font-weight-bold">Inicio</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/pedidos" @click="closeDrawer">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://static.vecteezy.com/system/resources/previews/012/714/703/original/carton-box-icon-and-illustration-vector.jpg" />
            </v-avatar>
          </template>
          <v-list-item-title>Pedidos</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="user.email === 'jorgepenagos50@gmail.com'" link to="/dashboard-admin" @click="closeDrawer">
           <template #prepend><v-icon class="mr-2">mdi-view-dashboard</v-icon></template>
           <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <!-- 👑 ADMIN: BOTÓN PARA FORZAR ACTUALIZACIÓN A TODOS -->
        <v-list-item v-if="user.email === 'jorgepenagos50@gmail.com'" link @click="triggerGlobalUpdate">
           <template #prepend><v-icon class="mr-2" color="purple-accent-4">mdi-cloud-upload</v-icon></template>
           <v-list-item-title v-if="user.email === 'jorgepenagos50@gmail.com'"  class="text-purple-accent-4 font-weight-bold">Forzar Actualización</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/user-info" @click="closeDrawer">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://img.icons8.com/emoji/48/bust-in-silhouette.png" />
            </v-avatar>
          </template>
          <v-list-item-title>Usuario</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2" />
        <v-list-item link @click="cerrarSesion">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://cdn-icons-png.flaticon.com/512/6811/6811880.png" />
            </v-avatar>
          </template>
          <v-list-item-title>Salir</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2" />
        <v-list-item link to="/aviso-privacidad">
           <template #prepend><v-icon class="mr-2">mdi-shield-check</v-icon></template>
           <v-list-item-title>Aviso de privacidad</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2" />
      

        <v-divider class="my-2" />
        <!-- 🚨 BOTÓN PARA FORZAR LIMPIEZA TOTAL -->
      
      </v-list>
    </v-navigation-drawer>

    <v-btn
      icon
      rounded="e-xl"
      color="orange-darken-3"
      class="drawer-toggle-btn elevation-4"
      @click="drawer = !drawer"
      style="position: fixed; top: 110px; left: 0; z-index: 100;"
    >
        <v-icon color="white">{{ drawer ? 'mdi-close' : 'mdi-menu' }}</v-icon>
    </v-btn>

    <v-sheet class="mb-4 pb-2 position-relative" style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px; overflow: hidden;" elevation="1">
        <v-carousel cycle :hide-delimiters="false" :show-arrows="false" height="200" interval="5000" hide-delimiter-background>
          <v-carousel-item v-for="(image, index) in bannerImages" :key="`banner-${index}`">
            <v-img :src="image" height="100%" class="align-center" :cover="false"></v-img>
          </v-carousel-item>
        </v-carousel>

        <v-sheet class="px-4 mt-4" color="transparent">
             <v-sheet class="d-flex overflow-x-auto pb-2" color="transparent" style="gap: 16px; scrollbar-width: none;">
                <v-sheet v-for="brand in brandList" :key="brand.name" 
                     class="d-flex flex-column align-center flex-shrink-0"
                     color="transparent"
                     @click="toggleBrandFilter(brand.name)"
                     style="cursor: pointer;">
                  <v-avatar size="60" :class="selectedBrand === brand.name ? 'active-brand' : 'inactive-brand'">
                    <v-img :src="brand.image" :cover="false"></v-img>
                  </v-avatar>
                  <span class="text-caption mt-1 text-truncate text-center" 
                        :class="selectedBrand === brand.name ? 'text-blue-darken-4 font-weight-bold' : 'text-grey-darken-1'"
                        style="width: 60px;">
                    {{ brand.name }}
                  </span>
                </v-sheet>
            </v-sheet>
        </v-sheet>
    </v-sheet>


    <v-sheet class="py-4 mb-6 mx-2 px-0" elevation="6" rounded="xl" 
         style="background: linear-gradient(135deg, #0D47A1 0%, #1976D2 50%, #42A5F5 100%);"> 
    
        <div class="px-4 mb-3 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
                <v-avatar color="rgba(255,255,255,0.2)" size="36" class="mr-3">
                    <v-icon color="white" size="22" class="animate-flicker">mdi-fire</v-icon>
                </v-avatar>
                <h2 class="text-h6 font-weight-black text-white" style="letter-spacing: 0.5px;">Más Vendidos</h2>
            </div>
            <v-chip color="rgba(255,255,255,0.2)" variant="flat" size="small" class="font-weight-bold text-white glass-chip">
                {{ filteredPromotions.length }} Activas
            </v-chip>
        </div>

        <!-- Scroll Nativo Capacitor -->
        <div class="native-scroll-container">
            <v-card v-for="promo in filteredPromotions" :key="'vende-' + promo.id" 
                    width="160" class="native-scroll-item app-promo-card" 
                    rounded="xl" elevation="4" @click="addToCart(promo)">
                
                <div v-if="promo.promo_price" class="glass-badge-discount">
                    🔥 -{{ promo.promo_price }}%
                </div>

                <div class="card-img-wrapper pb-2">
                    <v-img :src="promo.foto" height="110" contain class="card-img"></v-img>
                </div>

                <v-sheet class="pa-3 bg-white d-flex flex-column" style="border-radius: 0 0 24px 24px; min-height: 110px;">
                    <div class="text-caption text-grey-darken-4 font-weight-bold mb-1 card-title">{{ promo.nombre }}</div>
                    
                    <div class="d-flex align-center flex-wrap mb-2" style="gap: 4px;">
                        <span class="text-subtitle-1 font-weight-black text-blue-darken-4">
                            ${{ parseFloat(getPrecioFinal(promo)).toFixed(2) }}
                        </span>
                        <span v-if="promo.promo_price" class="text-caption text-grey text-decoration-line-through" style="font-size: 0.7rem !important;">
                            ${{ parseFloat(promo.price).toFixed(2) }}
                        </span>
                    </div>

                    <v-btn block color="blue-darken-4" class="text-white text-none font-weight-bold card-add-btn mt-auto" rounded="pill" elevation="2">
                       <v-icon left size="16" class="mr-1">mdi-cart-plus</v-icon> Agregar
                    </v-btn>
                </v-sheet>
            </v-card>
        </div>
    </v-sheet>

    <v-sheet class="py-4 mb-6 mx-2 px-0" elevation="3" rounded="xl" 
             style="background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%); border: 1px solid #FFCC80;"> 
        
        <div class="px-4 mb-3 d-flex align-center justify-space-between">
            <div class="d-flex align-center">
                <v-avatar color="orange-darken-4" size="36" class="mr-3 elevation-2">
                    <v-icon color="white" size="20">mdi-star-shooting</v-icon>
                </v-avatar>
                <h2 class="text-h6 font-weight-black text-orange-darken-4" style="letter-spacing: 0.5px;">Exclusivos Nissin</h2>
            </div>
        </div>

        <!-- Scroll Nativo Capacitor -->
        <div class="native-scroll-container">
            <v-card v-for="promo in filteredPromotions.filter(p => p.id === 17 || p.linea_prod_id?.includes('NISSIN'))" :key="'exclu-' + promo.id" 
                    width="160" class="native-scroll-item app-promo-card" 
                    rounded="xl" elevation="4" @click="addToCart(promo)">
                
                <div v-if="promo.promo_price" class="glass-badge-discount" style="background: rgba(230, 81, 0, 0.9);">
                    🤩 -{{ promo.promo_price }}%
                </div>

                <div class="card-img-wrapper pb-2 bg-white">
                    <v-img :src="promo.foto" height="110" contain class="card-img"></v-img>
                </div>

                <v-sheet class="pa-3 bg-white d-flex flex-column" style="border-radius: 0 0 24px 24px; min-height: 110px;">
                    <div class="text-caption text-grey-darken-4 font-weight-bold mb-1 card-title">{{ promo.nombre }}</div>
                    
                    <div class="d-flex align-center flex-wrap mb-2" style="gap: 4px;">
                        <span class="text-subtitle-1 font-weight-black text-orange-darken-4">
                            ${{ parseFloat(getPrecioFinal(promo)).toFixed(2) }}
                        </span>
                        <span v-if="promo.promo_price" class="text-caption text-grey text-decoration-line-through" style="font-size: 0.7rem !important;">
                            ${{ parseFloat(promo.price).toFixed(2) }}
                        </span>
                    </div>

                    <v-btn block color="orange-darken-4" class="text-white text-none font-weight-bold card-add-btn mt-auto" rounded="pill" elevation="2">
                        <v-icon left size="16" class="mr-1">mdi-cart-plus</v-icon> Agregar
                    </v-btn>
                </v-sheet>
            </v-card>
        </div>
    </v-sheet>
    <v-sheet class="py-4 mt-4 bg-white">
         <v-sheet class="text-center mb-2" color="transparent">
             <span class="text-overline text-grey">Marcas Oficiales</span>
         </v-sheet>
         <v-carousel cycle :hide-delimiters="true" :show-arrows="false" height="60" interval="2500" hide-delimiter-background>
            <v-carousel-item v-for="(item, idx) in transitions" :key="idx">
                <v-sheet class="d-flex justify-center align-center fill-height" color="transparent">
                    <v-img :src="item.image" max-width="120" max-height="50" contain></v-img>
                </v-sheet>
            </v-carousel-item>
         </v-carousel>
    </v-sheet>

    <v-sheet class="px-4 pb-16 mb-16" color="transparent">
        <v-card class="pa-4 bg-blue-darken-4 text-white rounded-xl mt-6" elevation="4">
            <v-sheet class="d-flex align-center justify-space-between" color="transparent">
                <v-sheet color="transparent">
                    <div class="text-subtitle-1 font-weight-bold">¿Necesitas Ayuda?</div>
                    <div class="text-caption opacity-80">Contáctanos por WhatsApp</div>
                </v-sheet>
                <v-btn icon color="green" size="large" class="elevation-4" href="https://wa.link/plk405" target="_blank">
                     <v-icon color="white" size="28">mdi-whatsapp</v-icon>
                </v-btn>
            </v-sheet>
        </v-card>
    </v-sheet>

    <v-snackbar v-model="snackbar" :timeout="1500" location="bottom" color="green-darken-1" rounded="pill" elevation="8" style="margin-bottom: 80px;">
      <v-sheet class="d-flex align-center justify-center" color="transparent">
         <v-icon start icon="mdi-check-circle" color="white"></v-icon>
         <span class="font-weight-bold">{{ snackbarText }}</span>
      </v-sheet>
    </v-snackbar>

    <CartDialog v-model="cartDialog" />

    <v-btn icon color="blue-darken-4" @click="openCart" elevation="10" 
           style="position: fixed; right: 20px; bottom: 100px; z-index: 2000; width: 60px; height: 60px;">
        <v-icon color="white" size="28">mdi-cart-outline</v-icon>
        <v-sheet v-if="totalCajas > 0" 
                 color="red" 
                 class="position-absolute d-flex align-center justify-center rounded-circle text-caption font-weight-bold text-white" 
                 style="top: 0; right: 0; width: 22px; height: 22px;">
            {{ totalCajas }}
        </v-sheet>
    </v-btn>

 
    </div>
  </div>
</template>

<style scoped>
/* Estilos necesarios para los estados visuales (Active/Inactive) */
.active-brand {
    border: 2px solid #1565C0;
    transform: scale(1.05);
    transition: all 0.3s ease;
}

.inactive-brand {
    border: 2px solid #e0e0e0;
    background-color: white;
    transition: all 0.3s ease;
}

/* Animación Fuego */
.animate-flicker { animation: flicker 2s infinite; }
@keyframes flicker {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.8; transform: scale(1.1); }
}

.v-sheet::-webkit-scrollbar {
    display: none;
}

/* Nuevo estilo CSS para scroll nativo Capacitior-friendly */
.native-scroll-container {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    gap: 16px;
    padding: 8px 16px 20px 16px; /* Extra padding bottom for shadows */
    scrollbar-width: none; /* Firefox */
    -webkit-overflow-scrolling: touch; /* iOS smooth scrolling */
}
.native-scroll-container::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
}
.native-scroll-item {
    scroll-snap-align: start;
    flex-shrink: 0;
}

/* Diseño de tarjeta premium */
.app-promo-card {
    transition: transform 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.2s;
    background: #ffffff;
    overflow: visible !important; /* To allow badges to pop out */
    display: flex;
    flex-direction: column;
}
.app-promo-card:active {
    transform: scale(0.96);
}
.card-img-wrapper {
    position: relative;
    padding-top: 16px;
    background: radial-gradient(circle at center, #f5f7fa 0%, #ffffff 70%);
    border-radius: 24px 24px 0 0;
}
.card-img {
    mix-blend-mode: multiply;
    transition: transform 0.3s ease;
}
.app-promo-card:active .card-img {
    transform: scale(0.95);
}
.card-title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 38px; /* fixed height for 2 lines */
    line-height: 1.3;
}
.glass-badge-discount {
    position: absolute;
    top: -10px;
    left: -10px;
    background: rgba(229, 57, 53, 0.95);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    color: white;
    font-weight: 900;
    font-size: 11px;
    padding: 6px 12px;
    border-radius: 12px;
    z-index: 10;
    box-shadow: 0 4px 12px rgba(229, 57, 53, 0.4);
    border: 1px solid rgba(255,255,255,0.3);
}
.glass-chip {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.home-scroll-container {
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)));
  overflow-y: auto;
  padding-bottom: 80px; /* Espacio para que el último elemento no quede tapado por el menú inferior */
  -webkit-overflow-scrolling: touch;
}
</style>
<script>
import api from "@/services/api";
import CartDialog from "./Administrador/CarritoViewStore.vue";
import { inject, computed, ref, shallowRef, onMounted, onBeforeUnmount } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useRouter } from "vue-router";
import { App } from '@capacitor/app';
import { Preferences } from "@capacitor/preferences";
import Swal from "sweetalert2";


export default {
  name: "HomeView",
  components: {  CartDialog, },

  setup() {
    const router = useRouter();
    const cartStore = inject("cartStore");
    const userStore = useUserStore();

    // 1. VARIABLES REACTIVAS
    const isLoading = ref(true);
    const isError = ref(false);
    const drawer = ref(false);
    const cartDialog = ref(false);
    const snackbar = ref(false);
    const snackbarText = ref("");
    
    let backButtonListener = null;
    let appStateListener = null;
    let promotionsInterval = null;

    const user = ref({});
    // 🚀 OPTIMIZACIÓN: shallowRef evita la reactividad profunda en listas grandes,
    // mejorando drásticamente el rendimiento en dispositivos lentos.
    const promotions = shallowRef([]);
    const promoGifts = shallowRef([]);
    const searchQuery = ref("");
    const selectedBrand = ref(null);
    const brandList = shallowRef([]);
    
    // Carrito
    const cart = ref(JSON.parse(localStorage.getItem("cart")) || []);

    // Datos estáticos
    const bannerImages = ref([
      "https://m.media-amazon.com/images/S/al-na-9d5791cf-3faf/bb6a00e6-cb70-4467-a5e7-940c8c94eeca._CR0%2C0%2C1500%2C750_SX1500_.jpg",
      "https://curator-assets.b-cdn.net/25ebb576-d66a-420b-9826-d6ca052340ea/382147560.jpg?width=850",
      "https://m.media-amazon.com/images/S/al-na-9d5791cf-3faf/9ccc47cc-bddc-4c0c-857e-d4780c5d8e98._CR0%2C0%2C1500%2C750_SX750_SY375_.jpg",
      "https://www.the-sun.com/wp-content/uploads/sites/6/2024/02/GettyImages-494579023jpg-JS312396427.jpg?strip=all&w=960",
      "https://vuala.com/img/prevent/3.webp",
      "https://grupomv.mx/images/sabores.webp",
      "https://valenetwork.mx/wp-content/uploads/2020/06/CARIBE-COOLER-playa-hor-1200x675.jpg",
      "https://m.media-amazon.com/images/I/61HjQDBJqRL.jpg"
    ]);

    const transitions = ref([
      { image: "https://www.penafiel.com/wp-content/themes/penafiel/images/penafiel-logo.png" },
      { image: "https://pngimg.com/uploads/red_bull/red_bull_PNG24.png" },
      { image: "https://cdn.uc.assets.prezly.com/8b851933-e208-4958-8d79-8bc2feebea74/-/resize/992/-/format/png/" },
      { image: "https://www.boones.mx/assets/images/logo-boones.png" },
      { image: "https://logos-world.net/wp-content/uploads/2021/09/Jack-Daniels-Logo.png" },
      { image: "https://grupomv.mx/images/logos/4.png" },
    ]);

    // 2. FUNCIONES Y COMPUTADOS
    
    // Wrapper para addToCart y mostrar snackbar si es necesario
    const addToCart = (item) => {
        cartStore.addToCart(item);
        snackbarText.value = "Producto agregado";
        snackbar.value = true;
    };

    async function cerrarSesion() {
      localStorage.clear();
      sessionStorage.clear();
      if (cartStore) cartStore.clearCart();
      await userStore.logout();
      window.location.href = "/login";
    }

    function closeDrawer() {
      drawer.value = false;
    }

    function openCart() {
      cartDialog.value = true;
    }

    const totalCajas = computed(() => {
      return cartStore?.state.cart.reduce((t, item) => t + item.quantity, 0) || 0;
    });

    const filteredPromotions = computed(() => {
      let result = promotions.value;
      if (selectedBrand.value) {
        result = result.filter(p => p.sublinea === selectedBrand.value);
      }
      if (searchQuery.value) {
        result = result.filter(p => p.nombre.toLowerCase().includes(searchQuery.value.toLowerCase()));
      }
      // Normalizamos la data al vuelo para visualización
      return result.map(p => normalizarPromo(p));
    });

    function normalizarPromo(promo) {
      const precioFinalVenta = Number(promo.precio_mostrador ?? promo.price);
      const promoPercent = Number(promo.promo_price ?? 0);
      const precioConPromo = promo.id_promocion && promoPercent > 0
          ? Number((precioFinalVenta * (1 - promoPercent / 100)).toFixed(2))
          : precioFinalVenta;

      return {
        ...promo,
        price: precioFinalVenta, // Precio original (tachado)
        precio_final: precioConPromo, // Precio con descuento
        promo_percent: promoPercent,
        promoUnico: true,
        iva: Number(promo.iva16 ?? 0),
        ieps: Number(promo.ieps ?? 0),
      };
    }
    
    // Helper para obtener el precio a mostrar en la tarjeta
    const getPrecioFinal = (promo) => {
        return promo.precio_final || promo.price;
    }

    // Función para reintentar carga manual
    async function retryLoad() {
      isLoading.value = true;
      isError.value = false;
      await fetchPromotions();
    }

    async function fetchPromotions() {
      const cacheKey = "promotionsCacheMain";
      const cacheTimeKey = cacheKey + "_time";
      const cache = localStorage.getItem(cacheKey);
      const cacheTime = Number(localStorage.getItem(cacheTimeKey));
      const now = Date.now();
      const cacheDuration = 5 * 60 * 1000; 

      const isPromotionActive = (promo) => {
        if (!promo.fecha_fin) return false;
        const fechaFin = new Date(promo.fecha_fin).getTime();
        return fechaFin >= Date.now();
      };

      if (cache && cacheTime && now - cacheTime < cacheDuration) {
        const cachedPromos = JSON.parse(cache).filter(isPromotionActive);
        promotions.value = cachedPromos;
        extractBrands(cachedPromos);
        isLoading.value = false; // ✅ Datos listos, mostrar UI
        isError.value = false;
        return;
      }

      try {
        const { data } = await api.get(
          "https://mvexpress.mx/api/promotions/promo-app",
        );
        const activePromotions = data.filter(isPromotionActive);
        promotions.value = activePromotions;
        extractBrands(activePromotions);
        
        localStorage.setItem(cacheKey, JSON.stringify(activePromotions));
        localStorage.setItem(cacheTimeKey, now.toString());
        isError.value = false;
      } catch (e) {
        isError.value = true; // 🔴 Marcamos error para mostrar la pantalla de aviso
        console.error("Error al obtener promociones:", e);
        // 🔥 Si el token es inválido (401) o prohibido (403), forzar logout
        if (e.response && (e.response.status === 401 || e.response.status === 403)) {
          localStorage.removeItem("token"); // Limpieza extra de seguridad
          localStorage.removeItem("user");
          await userStore.logout();
          router.replace("/login");
          return; // Detener ejecución
        }
      } finally {
        isLoading.value = false; // ✅ Termina carga (éxito o error controlado)
      }
    }

    function extractBrands(promoList) {
      const uniqueBrands = new Map();
      promoList.forEach(p => {
        if (p.sublinea && !uniqueBrands.has(p.sublinea)) {
          uniqueBrands.set(p.sublinea, p.foto || 'https://grupomv.mx/images/logo2.png');
        }
      });
      brandList.value = Array.from(uniqueBrands, ([name, image]) => ({ name, image }));
    }

    async function fetchPromoGifts() {
        // ... (Tu lógica existente para regalos)
    }

    function toggleBrandFilter(brandName) {
      selectedBrand.value = selectedBrand.value === brandName ? null : brandName;
    }

    // Función para probar el refresh token desde la UI
    function triggerTestToken() {
      userStore.testCorruptToken();
      drawer.value = false;
    }

    // Función para forzar limpieza total (Botón de pánico para clientes)
    async function forceResetApp() {
      const result = await Swal.fire({
        title: '¿Restablecer Aplicación?',
        text: "Esto borrará todos los datos locales, caché y cerrará tu sesión. Úsalo si la app presenta errores.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, restablecer',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        await userStore.logout(); // Esto ahora ejecuta Preferences.clear() borrando TODO
        window.location.href = "/login";
      }
    }

    // 🔄 SISTEMA DE RESET REMOTO
    // Permite forzar la limpieza de caché de todos los usuarios o usuarios específicos
    // simplemente incrementando un número en el backend.
    async function checkRemoteReset() {
      try {
        // 📡 Endpoint sugerido: GET /app-config/version
        // El backend debe devolver JSON: { "cache_version": 1 }
        // Si quieres resetear a todos, sube el número en tu backend (ej. a 2).
        const { data } = await api.get("https://mvexpress.mx/api/app-config/version");
        
        const serverVersion = data.cache_version || 0;
        const { value: localVersion } = await Preferences.get({ key: 'app_cache_version' });

        if (serverVersion > (Number(localVersion) || 0)) {
          console.log(`♻️ Reset remoto activado: v${localVersion} -> v${serverVersion}`);
          
          await Swal.fire({
            title: 'Actualizando App',
            text: 'Aplicando nuevas configuraciones...',
            timer: 2000,
            showConfirmButton: false,
            icon: 'info'
          });

          await userStore.logout(); // Borra todo (Preferences.clear)
          
          // 🔥 Guardamos la nueva versión DESPUÉS del logout para que no se borre
          await Preferences.set({ key: 'app_cache_version', value: String(serverVersion) });
          
          window.location.href = "/login";
        }
      } catch (e) {
        // Si falla (ej. endpoint no existe), no hacemos nada y sigue normal
      }
    }

    // 👑 ADMIN: Función para incrementar la versión en el backend
    async function triggerGlobalUpdate() {
      const result = await Swal.fire({
        title: '¿Forzar actualización global?',
        text: "Esto hará que TODOS los usuarios recarguen la app y borren su caché la próxima vez que entren.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#9C27B0',
        confirmButtonText: 'Sí, actualizar a todos'
      });

      if (result.isConfirmed) {
        try {
          // Llamamos al endpoint que incrementa la versión en el servidor
          await api.post("https://mvexpress.mx/api/app-config/update");
          Swal.fire("¡Listo!", "Se ha lanzado la nueva versión. Los clientes se actualizarán gradualmente.", "success");
        } catch (e) {
          Swal.fire("Error", "No se pudo contactar al servidor de configuración.", "error");
        }
      }
    }

    // 3. LIFECYCLE HOOKS
    onMounted(async () => {
      // 🔄 Restaurar sesión si se perdió por recarga (F5) o reinicio de app
      if (!userStore.token) {
        await userStore.initSession();
      }

      // 🔒 Validación de seguridad: Si no hay token, mandar al login
      if (!userStore.token) {
        await userStore.logout();
        router.replace("/login");
        return;
      }

      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        user.value = JSON.parse(storedUser);
      }

      checkRemoteReset(); // 🔍 Verificar versión de caché al iniciar
      
      // 📱 Verificar también al volver de segundo plano (si el usuario minimizó la app)
      appStateListener = await App.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
          checkRemoteReset();
        }
      });

      fetchPromotions();
      fetchPromoGifts();
      promotionsInterval = setInterval(fetchPromotions, 5 * 60 * 1000);

      // Listener botón físico
      backButtonListener = await App.addListener('backButton', () => {
        if (drawer.value) { drawer.value = false; return; }
        if (cartDialog.value) { cartDialog.value = false; return; }

        const currentPath = router.currentRoute.value.path;
        if (currentPath === '/home' || currentPath === '/') {
          App.minimizeApp();
        } else {
          router.back();
        }
      });
    });

    onBeforeUnmount(() => {
      if (promotionsInterval) clearInterval(promotionsInterval);
      if (backButtonListener) backButtonListener.remove();
      if (appStateListener) appStateListener.remove();
    });

    return {
      isLoading,
      bannerImages,
      transitions,
      promotions,
      promoGifts,
      searchQuery,
      snackbar,
      snackbarText,
      cartDialog,
      cart,
      addToCart,
      filteredPromotions,
      totalCajas,
      openCart,
      drawer,
      cerrarSesion,
      closeDrawer,
      user,
      brandList,
      selectedBrand,
      toggleBrandFilter,
      getPrecioFinal,
      triggerTestToken,
      forceResetApp,
      triggerGlobalUpdate,
      isError,
      retryLoad
    };
  },
};
</script>